<template>
    <div>
        <limitless-page-header>
            <template #header-elements>
                <limitless-page-header-button url="/suppliers/0" icon="icon-plus3">Ny leverantör</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <rednax-datatable :url="'/vue/suppliers'" :columns="table_columns" :filter="table_filter" sort-by="Name" sort-order="asc" @updateFilter="table_filter=$event" @rowclick="rowClick" history :per-page="100">
                <div class="row">
                    <div class="col-lg-3">
                        <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                    </div>
                </div>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';

export default {
    name: 'SupplierList',
    components: {
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        RednaxDatatable,
    },
    data: () => ({
        table_filter: {
            search: '',
        },
        table_columns: [
            {
                header: '#',
                data: 'ProdSupplierID',
                sortable: true,
                render(row) {
                    return '<a href="/suppliers/' + row.ProdSupplierID + '">' + (!row.isActive ? '<span style="color: #CC0000">' + row.ProdSupplierID + '</span>' : row.ProdSupplierID) + '</a>';
                },
            },
            {
                header: 'Namn',
                data: 'Name',
                sortable: true,
                render(row) {
                    return '<a href="/suppliers/' + row.ProdSupplierID + '">' + (!row.isActive ? '<span style="color: #CC0000">' + row.Name + '</span>' : row.Name) + '</a>';
                },
            },
            {
                header: 'Antal produkter',
                data: 'products_count',
                sortable: true,
                render(row) {
                    return (!row.isActive ? '<span style="color: #CC0000">' + row.products_count + '</span>' : row.products_count);
                },
            },
            {
                header: 'Status',
                data: 'isActive',
                sortable: true,
                render(row) {
                    return (!row.isActive ? '<div class="badge badge-danger">Inaktiv</div>' : '');
                },
            },
        ],
    }),
    methods: {
        rowClick(data, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                window.open('/suppliers/' + data.ProdSupplierID).focus();
            } else {
                window.location.href = '/suppliers/' + data.ProdSupplierID;
            }
        },
    },
};

</script>
